<template>
  <div class="share-component-popup">
    <vs-popup :title="$t('CurrentPermissions')" fullscreen style="z-index:54000;" :active.sync="InSharedWithList" v-if="InSharedWithList">
      <SharedWithComponent :shareObjectId="shareObjectId" :shareObjectType="shareObjectType"></SharedWithComponent>
    </vs-popup>

    <vs-tabs>
      <!-- Share Tab -->
      <vs-tab :label="$t('Share')">
        <div :active.sync="BeforeShare" v-if="BeforeShare">
          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-base mt-4">
              {{ $t('WhoShouldAccess') }}<br />
              <v-select v-model="ShareTypeObject" :options="ShareOptions">
              </v-select>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/1 w-full mb-base">
              <span v-if="ShareType === '0'">{{ $t('EmailLabel') }}</span>
              <span v-if="ShareType === '1'">{{ $t('DomainLabel') }}</span>
              <vs-input v-if="ShareType === '0' || ShareType === '1'"
                        class="vx-col w-1/1 lg:w-1/1"
                        style="width:100%;"
                        v-model="email" />
            </div>
          </div>

          <!-- View Options for "Anyone with the link" -->
          <div class="vx-row" v-if="ShareType === '2'">
            <div class="vx-col md:w-1/1 w-full mb-base">
              <label class="view-options-label">{{ $t('ViewMode') }}</label>
              <v-select v-model="selectedViewMode" :options="viewModeOptions" class="view-mode-select">
              </v-select>
              <small class="text-muted">{{ $t('ChooseDisplayMode') }}</small>
            </div>
          </div>

          <!-- Email Verification Toggle for "Anyone with the link" -->
          <div class="vx-row" v-if="ShareType === '2'">
            <div class="vx-col md:w-1/1 w-full mb-base">
              <vs-checkbox v-model="requireEmailVerification" class="email-verification-checkbox">
                {{ $t('AskEmailVerification') }}
              </vs-checkbox>
              <small class="text-muted">{{ $t('EmailVerificationDesc') }}</small>
            </div>
          </div>

          <div :active.sync="AfterShare" v-if="AfterShare">
            {{ $t('Link') }}<br />
            {{ $t('CopyLinkInstructions') }}<br />
            <p v-if="AfterShare">{{onboardingLink}}</p>

          </div>
        </div>
        <div :active.sync="BeforeShare" v-if="BeforeShare" class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-base">
            <vs-button id="share-button" class="vs-button-filled" @click="ShareOnboarding">{{ $t('Share') }}</vs-button>
          </div>

          <div class="vx-col md:w-1/2 w-full mb-base" style="text-align: right;">
            <vs-button id="share-button" class="vs-button-filled" @click="OpenSharedWith">{{ $t('Permissions') }}</vs-button>
          </div>
        </div>
        <div :active.sync="AfterShare" v-if="AfterShare">
          <div class="share-success-container">

            <div class="share-content">
              <div class="share-left">
                <div class="link-copy-container">
                  <vs-input v-model="onboardingLink" readonly class="share-link-input" />
                  <vs-button color="success" @click="CopyLink" icon-pack="feather" icon="icon-copy" icon-after class="copy-button"></vs-button>
                </div>
              </div>

              <div class="share-right">
                <div class="qr-code-container">
                  <canvas id="qrcode" ref="qrcode" class="qr-code"></canvas>
                </div>
              </div>
            </div>

            <div class="share-bottom">
              <vs-button color="primary" @click="CloseShareDialog" class="done-button">{{ $t('Done') }}</vs-button>
            </div>
          </div>
        </div>
      </vs-tab>

      <!-- Embed Tab -->
      <vs-tab :label="$t('Embed')">
        <div class="vx-row" id="embed-container">
          <div class="vx-col w-full">

            <div class="vx-row mt-4">
              <div class="vx-col md:w-1/2 w-full mb-base">
                <vs-button type="border" icon-pack="feather" icon="icon-check-square" @click="GenerateEmbedLink('steps', true)">
                  {{ $t('CheckListMode') }}
                </vs-button>
              </div>

              <div class="vx-col md:w-1/2 w-full mb-base">
                <vs-button type="border" icon-pack="feather" icon="icon-monitor" @click="GenerateEmbedLink('slideshow', true)">
                  {{ $t('SlideshowMode') }}
                </vs-button>
              </div>
            </div>

            <div v-if="embedLink" class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="embed-preview">
                      <iframe :src="embedLink" width="700" height="350" frameborder="0" style="border: 1px solid #ddd;"></iframe>
                    </div>
                  </div>
                  <vs-button color="success" @click="CopyEmbedCode" icon-pack="feather" icon="icon-copy" icon-after class="copy-button embed-copy-button">{{ $t('CopyCode') }}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>

      <!-- Export Tab -->
      <vs-tab :label="$t('Export')">
        <div class="vx-row mt-6">
          <!-- PDF Export -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToPDF') }}</div>
                <div class="export-description">{{ $t('PDFDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="exportPDFLinkedIn" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- PPTX Export -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToPowerPoint') }}</div>
                <div class="export-description">{{ $t('PowerPointDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="ExportToPPTX" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- TCVelik Export -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportForTCVelik') }}</div>
                <div class="export-description">{{ $t('TCVelikDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="ExportForTCVelik" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- HTML Export -->
          <div class="vx-col w-full mb-4 hidden-export">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToHTML') }}</div>
                <div class="export-description">{{ $t('HTMLDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="exportToHTML" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Markdown Export -->
          <div class="vx-col w-full mb-4 hidden-export">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToMarkdown') }}</div>
                <div class="export-description">{{ $t('MarkdownDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="exportToMarkdown" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Word Export -->
          <div class="vx-col w-full mb-4 hidden-export">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToWord') }}</div>
                <div class="export-description">{{ $t('WordDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="exportToWord" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Confluence Export -->
          <div class="vx-col w-full mb-4 hidden-export">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('ExportToConfluence') }}</div>
                <div class="export-description">{{ $t('ConfluenceDescription') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="exportToConfluence" size="small">
                  {{ $t('Export') }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>

      <!-- Copy as Snippet Tab -->
      <vs-tab :label="$t('CopyAsSnippet')">
        <div class="vx-row mt-6">
          <!-- Copy for Word -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('CopyForWord') }}</div>
                <div class="export-description">{{ $t('CopyForWordDesc') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="copyForWordGoogleOutlook" size="small">
                  {{ $t('Copy') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Copy for Google -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('CopyForGoogleDocs') }}</div>
                <div class="export-description">{{ $t('CopyForGoogleDocsDesc') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="copyForWordGoogleOutlook" size="small">
                  {{ $t('Copy') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Copy for Outlook -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('CopyForOutlook') }}</div>
                <div class="export-description">{{ $t('CopyForOutlookDesc') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="copyForWordGoogleOutlook" size="small">
                  {{ $t('Copy') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Copy for MS Teams -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('CopyForTeams') }}</div>
                <div class="export-description">{{ $t('CopyForTeamsDesc') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="copyForWordGoogleOutlook" size="small">
                  {{ $t('Copy') }}
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Copy for Confluence -->
          <div class="vx-col w-full mb-4">
            <div class="export-item">
              <div class="export-content">
                <div class="export-title">{{ $t('CopyForConfluence') }}</div>
                <div class="export-description">{{ $t('CopyForConfluenceDesc') }}</div>
              </div>
              <div class="export-action">
                <vs-button color="primary" @click="copyForConfluence" size="small">
                  {{ $t('Copy') }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <!-- Progress Popups -->
    <PDFProgressPopup :active="pdfProgressActive"
                      :current-step="pdfCurrentStep"
                      :total-steps="pdfTotalSteps"
                      @close="pdfProgressActive = false" />

    <GenericProgressPopup :active="genericProgressActive"
                          :current-step="genericCurrentStep"
                          :total-steps="genericTotalSteps"
                          @close="genericProgressActive = false" />
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import SharedWithComponent from '@/views/components/extra-components/share/SharedWithComponent.vue';
  import vSelect from 'vue-select'
  import QRCode from 'qrcode';
  import pptxgen from "pptxgenjs";
  import { preparePDFEnvironment } from '@/utils/PDFWorker';
  import PDFProgressPopup from '@/views/components/extra-components/pdf-progress/PDFProgressPopup.vue';
  import GenericProgressPopup from '@/views/components/extra-components/generic-progress/GenericProgressPopup.vue';
  import TCVelikExportImportService from '@/services/TCVelikExportImportService.js';

  export default {
    mounted() {
      this.ShareTypeObject = this.ShareOptions[0];
      this.ShareType = "0";
      // Initialize default view mode
      this.selectedViewMode = this.viewModeOptions[0]; // Default to checklist view
      // Check for existing public links for embed functionality
      this.CheckForExistingPublicLinks();
      // Auto-load Steps View for Embed tab
      this.loadDefaultEmbedView();
    },
    data() {
      return {
        ShareType: "0",
        email: "",
        InSharedWithList: false,
        BeforeShare: true,
        AfterShare: false,
        onboardingLink: "",
        ShareTypeObject: null,
        ShareOptions: [],
        // Embed functionality
        embedLink: "",
        embedCode: "",
        existingPublicLink: null,
        currentEmbedMode: "steps", // Track the currently selected embed mode
        // Export functionality
        pdfProgressActive: false,
        pdfCurrentStep: 0,
        pdfTotalSteps: 0,
        genericProgressActive: false,
        genericCurrentStep: 0,
        genericTotalSteps: 0,
        genericType: "",
        // Email verification toggle for "Anyone with the link"
        requireEmailVerification: false,
        // View mode selection for "Anyone with the link"
        selectedViewMode: null,
        viewModeOptions: []
      }
    },
    created() {
      // Initialize translated options
      this.ShareOptions = [
        { label: this.$t('SpecificPerson'), value: '0', example: 'e.g. someone@somedomain.com' },
        { label: this.$t('CompanyDomain'), value: '1', example: 'e.g. tcvelik.com to share with everyone who has @tcvelik.com email' },
        { label: this.$t('AnyoneWithLink'), value: '2' }
      ];
      this.viewModeOptions = [
        { label: this.$t('CheckListView'), value: 'checklist' },
        { label: this.$t('SlideshowView'), value: 'slideshow' }
      ];
    },
    props: ["shareObjectType", "shareObjectId"],
    watch: {
      "ShareTypeObject": function (newval, oldval) {
        if (newval) {
          this.ShareType = newval.value;
        }
        else
          this.Sharetype = "0";
      },
    },
    methods: {
      // Export functionality methods
      exportPDFLinkedIn() {
        var instance = this;

        (async () => {
          const { doc, pageSizeMM } = await preparePDFEnvironment();

          const sopTitle = document.querySelector('.sop-header h1')?.innerText.trim() || 'Untitled';
          const sopDescription = document.querySelector('.description p')?.innerText.trim() || '';
          const steps = Array.from(document.querySelectorAll('.print-content > div[data-step-id]'));

          // Show progress popup
          this.pdfProgressActive = true;
          this.pdfTotalSteps = steps.length + 1;

          const createCanvasFromLayout = async (titleText, descText, imgSrcs = [], isTitlePage = false) => {
            const layout = document.createElement('div');
            layout.style.width = '1080px';
            layout.style.height = '1080px';
            layout.style.display = 'flex';
            layout.style.flexDirection = 'column';
            layout.style.justifyContent = isTitlePage ? 'center' : 'flex-start';
            layout.style.alignItems = isTitlePage ? 'center' : 'flex-start';
            layout.style.background = 'linear-gradient(299deg, #69029a 0%, #000 100%)';
            layout.style.fontFamily = '"Outfit", sans-serif';
            layout.style.color = 'white';
            layout.style.padding = isTitlePage ? '0 100px' : '100px';
            layout.style.paddingTop = isTitlePage ? '0' : '108px';
            layout.style.boxSizing = 'border-box';

            const h1 = document.createElement('h1');
            h1.textContent = titleText;
            h1.style.fontSize = isTitlePage ? '72px' : '48px';
            h1.style.fontWeight = '900';
            h1.style.textAlign = isTitlePage ? 'center' : 'left';
            h1.style.margin = '0 0 12px 0';
            h1.style.color = 'white';
            layout.appendChild(h1);

            if (descText) {
              const p = document.createElement('p');
              p.textContent = descText;
              p.style.fontSize = '48px';
              p.style.fontWeight = '400';
              p.style.margin = '0 0 20px 0';
              p.style.color = 'white';
              p.style.textAlign = isTitlePage ? 'center' : 'left';
              p.style.maxWidth = '80%';
              layout.appendChild(p);
            }

            for (const src of imgSrcs) {
              const img = document.createElement('img');
              img.src = src;
              img.style.maxWidth = '80%';
              img.style.marginTop = '108px';
              img.style.borderRadius = '16px';
              img.style.alignSelf = 'center';
              layout.appendChild(img);
            }

            const container = document.createElement('div');
            container.style.position = 'fixed';
            container.style.left = '-9999px';
            container.style.width = '1080px';
            container.style.height = '1080px';
            container.appendChild(layout);
            document.body.appendChild(container);

            const canvas = await html2canvas(layout, { scale: 2 });
            document.body.removeChild(container);
            return canvas;
          };

          // Cover page
          this.pdfCurrentStep = 1;
          const coverCanvas = await createCanvasFromLayout(sopTitle, sopDescription, [], true);
          doc.addImage(coverCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, pageSizeMM, pageSizeMM);

          // Steps
          for (let i = 0; i < steps.length; i++) {
            this.pdfCurrentStep = i + 2;
            const step = steps[i];
            const ps = Array.from(step.querySelectorAll('p')).filter((p, idx) => idx !== 2 && (p.innerText.trim() || p.querySelector('img')));

            // Extract the step title from the first paragraph (which contains the title)
            const stepTitleElement = step.querySelector('p:first-child');
            const stepTitle = stepTitleElement ? stepTitleElement.innerText.trim() : `Step ${i + 1}`;

            // For the description, skip the first paragraph (title) and use the rest
            const contentPs = ps.slice(1); // Skip first paragraph which is the title
            const text = contentPs.map(p => p.innerText.trim()).filter(Boolean).join('\n\n');
            const imgs = ps.map(p => p.querySelector('img')?.src).filter(Boolean);

            const canvas = await createCanvasFromLayout(stepTitle, text, imgs);
            doc.addPage();
            doc.addImage(canvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, pageSizeMM, pageSizeMM);
          }

          this.pdfProgressActive = false;
          doc.save(instance.getOnboardingName() + ".pdf");
        })();
      },

      async ExportToPPTX() {
        this.genericCurrentStep = 0;
        this.genericTotalSteps = 0;
        this.genericType = "PPTX";
        var pptx = new pptxgen();
        var steps = Array.from(document.querySelectorAll('[data-type="draggable-item"]'));

        this.genericTotalSteps = steps.length;
        this.genericProgressActive = true;
        var first_slide = pptx.addSlide();

        first_slide.background = {
          color: '69029a'
        };

        first_slide.addText(this.getOnboardingName(), {
          x: 1,
          y: 2,
          w: 8,
          h: 2,
          fontSize: 36,
          color: 'FFFFFF',
          bold: true,
          align: 'center',
          valign: 'middle'
        });

        first_slide.addText(this.getOnboardingDescription(), {
          x: 1,
          y: 4,
          w: 8,
          h: 1.5,
          fontSize: 18,
          color: 'FFFFFF',
          bold: false,
          align: 'center',
          valign: 'top'
        });

        const convertToBase64 = async (url) => {
          const response = await fetch(url);
          const blob = await response.blob();
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        };

        for (var i = 0; i < steps.length; i++) {
          this.genericCurrentStep += 1;

          var slide = pptx.addSlide();

          slide.background = {
            color: '69029a'
          };

          var title = steps[i].getElementsByTagName('p')[0].innerText;
          var description = steps[i].getElementsByTagName('p')[1].innerText;
          var image = steps[i].getElementsByTagName('img')[0];

          slide.addText(title, {
            x: 1,
            y: 0.5,
            w: 8,
            h: 1,
            fontSize: 24,
            color: 'FFFFFF',
            bold: true,
            align: 'left'
          });

          slide.addText(description, {
            x: 1,
            y: 2.3,
            w: 7,
            h: 3,
            fontSize: 18,
            color: 'FFFFFF',
            bold: false,
            align: 'left',
            shrink: 'shrink',
            margin: 3,
            paraSpaceAfter: 2
          });

          let width, height;

          if (image) {
            const img = new Image();
            img.src = image.src;
            await new Promise(resolve => img.onload = resolve);

            const naturalWidth = img.naturalWidth;
            const naturalHeight = img.naturalHeight;
            const aspectRatio = naturalWidth / naturalHeight;

            const maxWidth = 6;
            const maxHeight = 3;

            if (aspectRatio > maxWidth / maxHeight) {
              width = maxWidth;
              height = maxWidth / aspectRatio;
            } else {
              height = maxHeight;
              width = maxHeight * aspectRatio;
            }

            const base64 = await convertToBase64(image.src);
            slide.addImage({
              data: base64,
              x: 2,
              y: 2,
              w: width,
              h: height
            });
          }
        }

        var copy_title = this.getOnboardingName();
        var pptx_title = copy_title.replace(/ /g, ""); // Replace ALL spaces, not just first one

        pptx.writeFile({ fileName: pptx_title })
          .then(fileName => {
            console.log(`created file: ${fileName}`);
          })
          .catch(error => {
            console.error('Error creating PPTX file:', error);
          });

        this.genericProgressActive = false;
      },

      // Copy functionality methods
      async copyForWordGoogleOutlook() {
        await this.copyHtmlWithImages(false);
      },

      async copyForConfluence() {
        await this.copyHtmlWithImages(true);
      },

      async copyHtmlWithImages(bSkipImageConversion) {
        var instance = this;

        const element = document.querySelector(".page-container");
        if (!element) {
          this.$vs.notify({
            title: this.$t('Error'),
            text: this.$t('ContentNotFound'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
          return;
        }

        // Clone the element to avoid modifying the original
        let clonedElement = element.cloneNode(true);

        clonedElement.classList.add("copy-container")

        var titles = clonedElement.querySelectorAll("[data-type='draggable-item'] p:first-child");
        titles.forEach(p => {
          var newNode = document.createElement('h2');
          newNode.innerHTML = p.innerHTML;
          p.parentNode.replaceChild(newNode, p);
        });

        var allToRemove = clonedElement.querySelectorAll("[data-type='draggable-item'] p:last-of-type");
        allToRemove.forEach(p => {
          p.remove();
        });

        var allNoPrints = clonedElement.querySelectorAll(".no-print");
        allNoPrints.forEach(elmt => {
          elmt.remove();
        })

        // Make the title bigger
        var sopTitle = clonedElement.querySelector(".sop-header h1");
        if (sopTitle) {
          sopTitle.style.fontSize = "2.0em";
          sopTitle.style.color = "purple";
        }

        // Remove complete button
        var completeButton = clonedElement.querySelector("#btn-complete");
        if (completeButton) {
          completeButton.remove();
        }

        // Add watermark
        var watermark_container = document.createElement('div');
        var watermark = document.createElement('img');
        watermark.src = "/logo.png";

        var powered_by_text = document.createElement('p');
        powered_by_text.style.fontSize = "24px";
        powered_by_text.style.display = "inline-block";
        powered_by_text.innerHTML = this.$t('PoweredBy') + " <strong>TCVelik</strong>";

        watermark_container.appendChild(watermark);
        watermark_container.appendChild(powered_by_text);
        clonedElement.appendChild(watermark_container);

        // Add link
        var link = document.createElement('a');
        link.href = window.location.href;
        link.innerHTML = this.$t('ClickLinkBetterExperience');
        clonedElement.appendChild(link);

        // Convert images to Base64 and collect real Blobs
        const images = clonedElement.querySelectorAll("img");
        const blobs = [];

        if (!bSkipImageConversion) {
          for (let img of images) {
            if (img.src.startsWith("data:") || img.src.startsWith("blob:")) continue; // Already handled

            try {
              const response = await fetch(img.src);
              const blob = await response.blob();
              blobs.push(blob); // collect the blob

              const reader = new FileReader();
              reader.readAsDataURL(blob);
              await new Promise(resolve => {
                reader.onloadend = () => {
                  img.src = reader.result; // replace img with base64
                  resolve();
                };
              });
            } catch (error) {
              console.warn("Failed to convert image:", img.src, error);
            }
          }
        }
        // Prepare ClipboardItem
        const clipboardContent = {
          "text/html": new Blob([clonedElement.outerHTML], { type: "text/html" })
        };

        try {
          await navigator.clipboard.write([
            new ClipboardItem(clipboardContent)
          ]);
          instance.$vs.notify({
            title: instance.$t('SOPCopiedToClipboard'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        } catch (err) {
          console.error("Clipboard write failed", err);
          instance.$vs.notify({
            title: instance.$t('ErrorCopyingSOPToClipboard'),
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      },

      async ExportForTCVelik() {
        const editorContent = document.querySelector('.print-content') ? document.querySelector('.print-content').innerHTML : '';
        
        const result = await TCVelikExportImportService.exportToTCVelik({
          title: this.getOnboardingName(),
          description: this.getOnboardingDescription(),
          htmlContent: editorContent,
          progressCallback: (progress) => {
            this.genericType = progress.type;
            this.genericProgressActive = progress.active;
            this.genericCurrentStep = progress.currentStep;
            this.genericTotalSteps = progress.totalSteps;
          }
        });

        if (!result.success) {
          console.error('Export failed:', result.error);
          this.$vs.notify({
            title: "Export failed",
            text: result.error,
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      },

      // Placeholder methods for additional export formats
      exportToHTML() {
        this.$vs.notify({
          title: this.$t('ComingSoon'),
          text: this.$t('HTMLExportSoon'),
          color: "warning",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-info",
        });
      },

      exportToMarkdown() {
        this.$vs.notify({
          title: this.$t('ComingSoon'),
          text: this.$t('MarkdownExportSoon'),
          color: "warning",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-info",
        });
      },

      exportToWord() {
        this.$vs.notify({
          title: this.$t('ComingSoon'),
          text: this.$t('WordExportSoon'),
          color: "warning",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-info",
        });
      },

      exportToConfluence() {
        this.$vs.notify({
          title: this.$t('ComingSoon'),
          text: this.$t('ConfluenceExportSoon'),
          color: "warning",
          iconPack: "feather",
          position: "top-center",
          icon: "icon-info",
        });
      },

      getOnboardingName() {
        // Get onboarding name from DOM or parent component
        const titleElement = document.querySelector('.sop-header h1');
        return titleElement ? titleElement.innerText.trim() : 'Untitled';
      },

      getOnboardingDescription() {
        // Get onboarding description from DOM or parent component
        const descElement = document.querySelector('.description p');
        return descElement ? descElement.innerText.trim() : '';
      },

      ShareOnboarding() {
        var instance = this;
        if (instance.email == '' && instance.ShareType != "2") {
          instance.$vs.notify({
            title: instance.$t('FieldCannotBeEmpty'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });

          return
        }

        TCVelikClient.PostRelative("/api/share/ShareOnboarding?targetObjectId=" + instance.shareObjectId + "&ToEmail=" + instance.email + "&shareType=" + instance.ShareType + "&shareObjectType=" + instance.shareObjectType + "&targetAudience=" + instance.email + "&requireEmailVerification=" + instance.requireEmailVerification)
          .then(function (response) {
            if (response && response.data && response.data.Success) {
              let link = response.data.Link;
              
              // Add mode parameter if slideshow is selected
              if (instance.ShareType === "2" && instance.selectedViewMode && instance.selectedViewMode.value === "slideshow") {
                link += (link.includes('?') ? '&' : '?') + 'mode=slideshow';
              }
              
              instance.onboardingLink = link;
              instance.BeforeShare = false;
              instance.AfterShare = true;
              instance.$vs.notify({
                title: instance.$t('Success'),
                text: instance.$t('SuccessfullyShared') + ' ' + response.data.ShareObject,
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });

              instance.$nextTick(function () {
                const canvas = instance.$refs.qrcode;
                QRCode.toCanvas(canvas, instance.onboardingLink, function (error) {
                  if (error) console.error(error);
                });
              });
            }
            else if (response && response.data && response.data.errors) {
              alert(instance.$t('ErrorsSharingOnboarding') + ' ' + response.data.ShareObject + ':(');

            }
          });
      },
      CopyLink() {
        var instance = this;
        this.$copyText(this.onboardingLink).then(
          function () {
            instance.$vs.notify({
              title: instance.$t('Success'),
              text: instance.$t('TextCopiedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      },
      OpenSharedWith() {
        this.InSharedWithList = true
      },

      CloseShareDialog() {
        this.AfterShare = false;
        this.BeforeShare = true;
        this.onboardingLink = "";
      },

      // Embed functionality methods
      async GenerateEmbedLink(mode, liveMode) {
        var instance = this;
        try {
          // Update the current embed mode
          instance.currentEmbedMode = mode;
          
          // First check if we already have a public link
          if (!instance.existingPublicLink) {
            await instance.EnsurePublicLinkExists();
          }

          if (instance.existingPublicLink) {
            // Generate the embed link based on mode
            const baseUrl = instance.existingPublicLink;
            let embedUrl = mode === 'slideshow' ? baseUrl + '&mode=slideshow' : baseUrl;

            // Add preview parameter for iframe preview (not for the actual shared link)
            embedUrl += !(liveMode) ? '&preview=1' : '';

            instance.embedLink = embedUrl;
            
            // Build the embed code with optional branding link
            let embedCode = `<iframe src="${embedUrl}" width="100%" height="600px" allow="fullscreen" allowfullscreen frameborder="0" style="border: 1px solid #ddd;"></iframe>`;
            
            // Add "Recorded with TCVelik" branding link for specific domains
            if (instance.shouldIncludeBranding()) {
              embedCode += instance.getBrandingHtml();
            }
            
            instance.embedCode = embedCode;

          } else {
            instance.$vs.notify({
              title: instance.$t('Error'),
              text: instance.$t('FailedCreatePublicLink'),
              color: "danger",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-alert-circle",
            });
          }
        } catch (error) {
          instance.$vs.notify({
            title: instance.$t('Error'),
            text: instance.$t('FailedGenerateEmbedLink'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      },
      
      shouldIncludeBranding() {
        const hostname = window.location.hostname;
        return hostname === 'webstack.tcvelik.com' || 
               hostname.includes('webstack.azurewebsites.net') ||
               hostname === 'localhost';
      },
      
      getBrandingHtml() {
        return `
<div style="margin-top: 8px; text-align: center;">
  <a href="https://tcvelik.com" target="_blank" rel="noopener noreferrer" style="display: inline-flex; align-items: center; gap: 6px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; color: #6b7280; text-decoration: none; padding: 4px 8px; border-radius: 4px; transition: color 0.2s ease;">
    <span style="color: #6b7280;">Recorded with</span>
    <span style="font-weight: 700; background: linear-gradient(135deg, #a858f7 0%, #667eea 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">TCVelik</span>
  </a>
</div>`;
      },

      async EnsurePublicLinkExists() {
        var instance = this;

        // Check if we already have a public link
        const existingLinks = await instance.GetExistingSharedLinks();
        const publicLink = existingLinks.find(link => link.ShareType === 2);

        if (publicLink) {
          // Use existing public link
          instance.existingPublicLink = instance.BuildPublicUrl(publicLink.Token);
        } else {
          // Create new public link
          const newLink = await instance.CreatePublicLink();
          if (newLink) {
            instance.existingPublicLink = newLink;
          }
        }
      },

      async GetExistingSharedLinks() {
        var instance = this;
        try {
          const response = await TCVelikClient.GetRelative("/api/share/GetAllSharedItems?id=" + instance.shareObjectId + "&shareObjectType=" + instance.shareObjectType);
          return response && response.data ? response.data : [];
        } catch (error) {
          console.error('Error fetching shared links:', error);
          return [];
        }
      },

      async CreatePublicLink() {
        var instance = this;
        try {
          const response = await TCVelikClient.PostRelative("/api/share/ShareOnboarding?targetObjectId=" + instance.shareObjectId + "&ToEmail=&shareType=2&shareObjectType=" + instance.shareObjectType + "&targetAudience=&requireEmailVerification=" + instance.requireEmailVerification);

          if (response && response.data && response.data.Success) {
            // Extract the token from the backend response and build the URL using frontend's method
            const backendUrl = response.data.Link;
            const urlParams = new URLSearchParams(backendUrl.split('?')[1]);
            const token = urlParams.get('token');

            if (token) {
              return instance.BuildPublicUrl(token);
            }
          }
        } catch (error) {
          console.error('Error creating public link:', error);
        }
        return null;
      },

      BuildPublicUrl(token) {
        // Build the public URL based on the current host
        const host = window.location.origin;
        return `${host}/pages/pdf-view?oid=${this.shareObjectId}&token=${token}`;
      },

      async CopyEmbedCode() {
        var instance = this;
        await this.GenerateEmbedLink(instance.currentEmbedMode, true);
        this.$copyText(this.embedCode).then(
          function () {
            instance.$vs.notify({
              title: instance.$t('Success'),
              text: instance.$t('EmbedCodeCopied'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      },

      async CheckForExistingPublicLinks() {
        var instance = this;
        try {
          const existingLinks = await instance.GetExistingSharedLinks();
          const publicLink = existingLinks.find(link => link.ShareType === 2);

          if (publicLink) {
            instance.existingPublicLink = instance.BuildPublicUrl(publicLink.Token);
          }
        } catch (error) {
          console.error('Error checking for existing public links:', error);
        }
      },

      // Auto-load Steps View for Embed tab
      async loadDefaultEmbedView() {
        await this.GenerateEmbedLink('steps');
      }
    },
    computed: {
      ShareTypeExample() {
        if (this.ShareTypeObject) {
          return this.ShareTypeObject.example;
        }
        return "";
      }
    },
    components: {
      SharedWithComponent,
      vSelect,
      PDFProgressPopup,
      GenericProgressPopup,
    }
  }
</script>

<style>

  .vs-tabs-primary .vs-tabs--content .activeChild button, .vs-tabs-primary .vs-tabs--content button:not(:disabled):hover {
    color: var(--text-primary) !important;
  }

  .embed-option {
    transition: all 0.3s ease;
  }

    .embed-option:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

  .embed-option-active {
    background-color: var(--vs-primary) !important;
    color: white !important;
    border-color: var(--vs-primary) !important;
  }

    .embed-option-active:hover {
      background-color: var(--vs-primary-dark) !important;
      border-color: var(--vs-primary-dark) !important;
    }

  .embed-preview {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    padding: 16px;
  }

  .embed-code-input {
    font-family: 'Courier New', monospace;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
  }

  .copy-button {
    margin-top: 8px;
  }

  .embed-copy-button {
    display: block;
    margin: 16px auto 0 auto;
    width: fit-content;
  }

  .export-option {
    transition: all 0.3s ease;
  }

    .export-option:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

  /* Export Item Styles */
  .export-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    transition: all 0.3s ease;
  }

    .export-item:hover {
      border-color: #cbd5e1;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

  .export-icon {
    width: 48px;
    height: 48px;
    background: #f1f5f9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    flex-shrink: 0;
  }

    .export-icon i {
      font-size: 20px;
      color: #64748b;
    }

  .export-content {
    flex: 1;
    min-width: 0;
    padding-left: 0;
  }

  .export-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
  }

  .export-description {
    font-size: 14px;
    color: #64748b;
    line-height: 1.4;
  }

  .export-action {
    margin-left: 16px;
    flex-shrink: 0;
  }

  /* Hide specific export options */
  .hidden-export {
    display: none;
  }

  /* Share Success Layout Styles */
  .share-success-container {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .share-instruction {
    font-size: 16px;
    color: #374151;
    text-align: center;
    font-weight: 500;
    margin: 0;
  }

  .share-content {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    max-width: 100%;
    min-height: 200px;
  }

  .share-left {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .share-right {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qr-code-container {
    background: white;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .qr-code {
    display: block;
    width: 160px;
    height: 160px;
  }

  .share-link-input {
    flex: 1;
    min-width: 0;
  }

  .share-bottom {
    display: flex;
    justify-content: center;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
  }

  .done-button {
    min-width: 120px;
  }

  /* Responsive design for smaller screens */
  @media (max-width: 768px) {
    .share-content {
      flex-direction: column;
      gap: 24px;
      min-height: auto;
    }

    .share-right {
      order: -1;
    }

    .qr-code {
      width: 120px;
      height: 120px;
    }

    .share-bottom {
      padding-top: 20px;
    }
  }

  /* Link copy container styles */
  .link-copy-container {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

    .link-copy-container .vs-input {
      flex: 1;
    }

    .link-copy-container .copy-button {
      margin-top: 0;
      white-space: nowrap;
    }

  /* Override Vuesax popup content width - only for ShareComponent */
  .share-component-popup :deep(.vs-popup) {
    max-width: 90vw !important;
    width: 90vw !important;
  }

  .share-component-popup :deep(.vs-popup .vs-popup--content) {
    max-width: 100% !important;
    width: 100% !important;
    padding: 20px !important;
  }

  /* Email verification checkbox styling */
  .email-verification-checkbox {
    margin-bottom: 8px;
  }

    .email-verification-checkbox .vs-checkbox--label {
      font-weight: 500;
      color: #374151;
    }

  .text-muted {
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  /* View options styling */
  .view-options-label {
    display: block;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
  }

  .view-mode-select {
    margin-bottom: 8px;
  }
</style>
